'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['\n        width: 60px;\n        height: 60px;\n    '], ['\n        width: 60px;\n        height: 60px;\n    ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactBodymovin = require('react-bodymovin');

var _reactBodymovin2 = _interopRequireDefault(_reactBodymovin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var favoritingAnimation = {
    v: '5.1.16',
    fr: 29.9700012207031,
    ip: 17.0000006924242,
    op: 54.0000021994651,
    w: 50,
    h: 50,
    nm: 'clayton-heart-animation-Favoriting',
    ddd: 0,
    assets: [],
    layers: [{
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: 'clayton-heart-animation Outlines',
        sr: 1,
        ks: {
            o: {
                a: 1,
                k: [{
                    i: {
                        x: [0.833],
                        y: [0.833]
                    },
                    o: {
                        x: [0.167],
                        y: [0.167]
                    },
                    n: ['0p833_0p833_0p167_0p167'],
                    t: 0,
                    s: [100],
                    e: [100]
                }, {
                    i: {
                        x: [0.833],
                        y: [0.833]
                    },
                    o: {
                        x: [0.167],
                        y: [0.167]
                    },
                    n: ['0p833_0p833_0p167_0p167'],
                    t: 29,
                    s: [100],
                    e: [100]
                }, {
                    i: {
                        x: [0.833],
                        y: [0.833]
                    },
                    o: {
                        x: [0.167],
                        y: [0.167]
                    },
                    n: ['0p833_0p833_0p167_0p167'],
                    t: 30,
                    s: [100],
                    e: [100]
                }, {
                    i: {
                        x: [0.833],
                        y: [0.833]
                    },
                    o: {
                        x: [0.167],
                        y: [0.167]
                    },
                    n: ['0p833_0p833_0p167_0p167'],
                    t: 98,
                    s: [100],
                    e: [50]
                }, {
                    t: 99.0000040323527
                }],
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [24.2, 27.4, 0],
                ix: 2
            },
            a: {
                a: 0,
                k: [25, 25, 0],
                ix: 1
            },
            s: {
                a: 1,
                k: [{
                    i: {
                        x: [0.723, 0.723, 0.875],
                        y: [1.012, 1.012, 1]
                    },
                    o: {
                        x: [1, 1, 0.167],
                        y: [-0.134, -0.134, 0]
                    },
                    n: ['0p723_1p012_1_-0p134', '0p723_1p012_1_-0p134', '0p875_1_0p167_0'],
                    t: 17,
                    s: [60, 60, 100],
                    e: [0, 0, 100]
                }, {
                    i: {
                        x: [0.667, 0.667, 0.667],
                        y: [1, 1, 1]
                    },
                    o: {
                        x: [0.369, 0.369, 0.167],
                        y: [0.009, 0.009, 0]
                    },
                    n: ['0p667_1_0p369_0p009', '0p667_1_0p369_0p009', '0p667_1_0p167_0'],
                    t: 29,
                    s: [0, 0, 100],
                    e: [60, 60, 100]
                }, {
                    i: {
                        x: [0.667, 0.667, 0.667],
                        y: [1, 1, 1]
                    },
                    o: {
                        x: [0.333, 0.333, 0.333],
                        y: [0, 0, 0]
                    },
                    n: ['0p667_1_0p333_0', '0p667_1_0p333_0', '0p667_1_0p333_0'],
                    t: 36,
                    s: [60, 60, 100],
                    e: [47.03, 47.03, 100]
                }, {
                    i: {
                        x: [0.296, 0.296, 0.667],
                        y: [0.982, 0.982, 1]
                    },
                    o: {
                        x: [0.333, 0.333, 0.333],
                        y: [0, 0, 0]
                    },
                    n: ['0p296_0p982_0p333_0', '0p296_0p982_0p333_0', '0p667_1_0p333_0'],
                    t: 43,
                    s: [47.03, 47.03, 100],
                    e: [60, 60, 100]
                }, {
                    i: {
                        x: [0.296, 0.296, 0.667],
                        y: [1, 1, 1]
                    },
                    o: {
                        x: [0, 0, 0],
                        y: [0, 0, 0]
                    },
                    n: ['0p296_1_0_0', '0p296_1_0_0', '0p667_1_0_0'],
                    t: 52,
                    s: [60, 60, 100],
                    e: [60, 60, 100]
                }, {
                    i: {
                        x: [0.833, 0.833, 0.833],
                        y: [1, 1, 1]
                    },
                    o: {
                        x: [0, 0, 0],
                        y: [0, 0, 0]
                    },
                    n: ['0p833_1_0_0', '0p833_1_0_0', '0p833_1_0_0'],
                    t: 92,
                    s: [60, 60, 100],
                    e: [0, 0, 100]
                }, {
                    i: {
                        x: [0.296, 0.296, 0.667],
                        y: [1, 1, 1]
                    },
                    o: {
                        x: [0.167, 0.167, 0.167],
                        y: [0, 0, 0]
                    },
                    n: ['0p296_1_0p167_0', '0p296_1_0p167_0', '0p667_1_0p167_0'],
                    t: 98,
                    s: [0, 0, 100],
                    e: [60, 60, 100]
                }, {
                    t: 108.00000439893
                }],
                ix: 6
            }
        },
        ao: 0,
        shapes: [{
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 2.815], [6.626, 0], [0, -6.391], [6.626, 0], [0, -6.391], [-1.731, -2.007], [0, 0], [0, 0], [-0.502, -0.384], [0, 0], [0, 0], [-0.434, 0.455], [0, 0]],
                        o: [[1.731, -2.007], [0, -6.391], [-6.629, 0], [0, -6.391], [-6.629, 0], [0, 2.815], [0, 0], [0, 0], [0.436, 0.458], [0, 0], [0, 0], [0.503, -0.38], [0, 0], [0, 0]],
                        v: [[21.187, 0.082], [24, -7.285], [12.002, -18.857], [0, -7.285], [-11.998, -18.857], [-24, -7.285], [-21.186, 0.082], [-21.308, 0.082], [-20.809, 0.523], [-19.395, 1.769], [0, 18.857], [19.396, 1.765], [20.81, 0.523], [21.309, 0.082]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.638999968884, 0.638999968884, 0.647000002394, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 1,
                    k: [{
                        i: {
                            x: [0.833],
                            y: [0.833]
                        },
                        o: {
                            x: [0.167],
                            y: [0.167]
                        },
                        n: ['0p833_0p833_0p167_0p167'],
                        t: 26,
                        s: [1],
                        e: [0]
                    }, {
                        t: 29.0000011811942
                    }],
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [25, 24.5],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 2,
            cix: 2,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'fl',
            c: {
                a: 1,
                k: [{
                    i: {
                        x: [0.833],
                        y: [0.833]
                    },
                    o: {
                        x: [0.167],
                        y: [0.167]
                    },
                    n: ['0p833_0p833_0p167_0p167'],
                    t: 0,
                    s: [1, 1, 1, 1],
                    e: [1, 1, 1, 1]
                }, {
                    i: {
                        x: [0.833],
                        y: [0.833]
                    },
                    o: {
                        x: [0.167],
                        y: [0.167]
                    },
                    n: ['0p833_0p833_0p167_0p167'],
                    t: 26,
                    s: [1, 1, 1, 1],
                    e: [0.937254905701, 0.29411765933, 0.364705890417, 1]
                }, {
                    t: 29.0000011811942
                }],
                ix: 4
            },
            o: {
                a: 0,
                k: 100,
                ix: 5
            },
            r: 1,
            nm: 'Fill 1',
            mn: 'ADBE Vector Graphic - Fill',
            hd: false
        }],
        ip: 0,
        op: 899.000036617021,
        st: 0,
        bm: 0
    }, {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: 'Shape Layer 2',
        sr: 1,
        ks: {
            o: {
                a: 1,
                k: [{
                    i: {
                        x: [0.833],
                        y: [0.833]
                    },
                    o: {
                        x: [0.167],
                        y: [0.167]
                    },
                    n: ['0p833_0p833_0p167_0p167'],
                    t: 33,
                    s: [16],
                    e: [0]
                }, {
                    t: 43.0000017514259
                }],
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [24.346, 24.363, 0],
                ix: 2
            },
            a: {
                a: 0,
                k: [0, 0, 0],
                ix: 1
            },
            s: {
                a: 1,
                k: [{
                    i: {
                        x: [0.155, 0.155, 0.833],
                        y: [0.986, 0.986, 1]
                    },
                    o: {
                        x: [0.167, 0.167, 0.167],
                        y: [0.167, 0.167, 16.808]
                    },
                    n: ['0p155_0p986_0p167_0p167', '0p155_0p986_0p167_0p167', '0p833_1_0p167_16p808'],
                    t: 24,
                    s: [0, 0, 100],
                    e: [119, 119, 100]
                }, {
                    t: 40.0000016292334
                }],
                ix: 6
            }
        },
        ao: 0,
        shapes: [{
            ty: 'gr',
            it: [{
                d: 1,
                ty: 'el',
                s: {
                    a: 0,
                    k: [35.845, 35.845],
                    ix: 2
                },
                p: {
                    a: 0,
                    k: [0, 0],
                    ix: 3
                },
                nm: 'Ellipse Path 1',
                mn: 'ADBE Vector Shape - Ellipse',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [0.937254901961, 0.294117647059, 0.364705882353, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [0.154, 0.137],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Ellipse 1',
            np: 3,
            cix: 2,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: false
        }],
        ip: 0,
        op: 899.000036617021,
        st: 0,
        bm: 0
    }],
    markers: []
};


var HeartAnimationFave = function HeartAnimationFave(_ref) {
    var autoplay = _ref.autoplay;


    var HeartAnimationContainer = _styledComponents2.default.div(_templateObject);

    var bodymovinOptions = {
        loop: false,
        autoplay: { autoplay: autoplay },
        prerender: true,
        animationData: favoritingAnimation
    };

    return _react2.default.createElement(
        HeartAnimationContainer,
        null,
        _react2.default.createElement(_reactBodymovin2.default, { options: bodymovinOptions })
    );
};

exports.default = HeartAnimationFave;


//////////////////
// WEBPACK FOOTER
// ./~/pubweb-react-components/dist/components/Favoriting/HeartAnimationFave.js
// module id = 474
// module chunks = 168707334958949